<template>
  <div>
    <Header @showModal="showModal" @getCode="getCode" />
    <!-- ======= Hero Section ======= -->
    <section id="hero" class="hero d-flex align-items-center">
      <div class="container">
        <div class="row gy-4 d-flex justify-content-between">
          <div
            class="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center">
            <h2 data-aos="fade-up">Golai.Express</h2>
            <p data-aos="fade-up" data-aos-delay="100">
              С Golai.Express отслеживание вашего груза по трек-коду — это
              просто и надежно. Введите код и узнайте местонахождение вашего
              товара в режиме реального времени. Быстро, прозрачно, уверенно —
              всегда под контролем с Golai.Express!
            </p>

            <form
              action="#"
              class="form-search d-flex align-items-stretch mb-3"
              data-aos="fade-up"
              data-aos-delay="200">
              <input
                v-model="search"
                type="text"
                class="form-control"
                placeholder="Введите трек код вашего товара" />
              <button
                type="submit"
                class="btn btn-primary"
                @click.prevent="searchGood">
                Поиск...
              </button>
            </form>

            <!-- <div class="row gy-4" data-aos="fade-up" data-aos-delay="400">
              <div class="col-lg-3 col-6">
                <div class="stats-item text-center w-100 h-100">
                  <span
                    data-purecounter-start="0"
                    data-purecounter-end="232"
                    data-purecounter-duration="1"
                    class="purecounter"
                    >12</span
                  >
                  <p>Наши клиенты</p>
                </div>
              </div>

              <div class="col-lg-3 col-6">
                <div class="stats-item text-center w-100 h-100">
                  <span
                    data-purecounter-start="0"
                    data-purecounter-end="521"
                    data-purecounter-duration="1"
                    class="purecounter"></span>
                  <p>Projects</p>
                </div>
              </div>

              <div class="col-lg-3 col-6">
                <div class="stats-item text-center w-100 h-100">
                  <span
                    data-purecounter-start="0"
                    data-purecounter-end="1453"
                    data-purecounter-duration="1"
                    class="purecounter"></span>
                  <p>Support</p>
                </div>
              </div>

              <div class="col-lg-3 col-6">
                <div class="stats-item text-center w-100 h-100">
                  <span
                    data-purecounter-start="0"
                    data-purecounter-end="32"
                    data-purecounter-duration="1"
                    class="purecounter"></span>
                  <p>Workers</p>
                </div>
              </div>
            </div>-->
          </div>

          <div class="col-lg-5 order-1 order-lg-2 hero-img" data-aos="zoom-out">
            <img
              src="../../assets/img/hero-img.svg"
              class="img-fluid mb-3 mb-lg-0"
              alt="" />
          </div>
        </div>
      </div>
    </section>
    <div
      v-if="searchItem && searchItem?.length > 0"
      class="row gy-4 pa-4"
      data-aos="fade-up"
      data-aos-delay="400">
      <div class="col-lg-12 col-12">
        <v-data-table
          :headers="headers"
          :items="searchItem"
          :header-props="headerProps"
          disable-pagination
          hide-default-footer>
          <template v-slot:[`item.index`]="{ index }">
            <span style="color: #427ad4">{{ index + 1 }}</span>
          </template>

          <template v-slot:[`item.send_date`]="{ item }">
            <span>{{ dateFormat(item.send_date) }}</span>
          </template>
          <template v-slot:[`item.arrival_date`]="{ item }">
            <span>{{ dateFormat(item.arrival_date) }}</span>
          </template>
          <template v-slot:[`item.region_code`]="{ item }">
            <span>{{ findRegion(item.region_code) }}</span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <StatusCard :status="item.status" />
          </template>

          <template v-slot:no-data>
            <div>Товаров нет</div>
          </template>
        </v-data-table>
      </div>
    </div>
    <!-- End Hero Section -->
    <Content @getCode="getCode" />
    <Footer @showModal="showModal" @getCode="getCode" />
    <LoginModal :isOpen="isOpen" @cancel="closeModal" />
  </div>
</template>
<script>
import Content from "../../components/main/Content.vue";
import Header from "../../components/main/Header.vue";
import Footer from "../../components/main/Footer.vue";
import LoginModal from "../auth/LoginModal.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import StatusCard from "@/components/StatusCard/StatusCard.vue";
export default {
  name: "HomePage",
  components: {
    Content,
    Header,
    Footer,
    LoginModal,
    StatusCard,
  },
  data() {
    return {
      search: "",
      searchItem: [],
      headers: [
        {
          text: "#",
          align: "start",
          value: "index",
        },
        {
          text: "Дата отправки",
          value: "send_date",
        },
        {
          text: "Дата поступления",
          value: "arrival_date",
        },
        {
          text: "Трек код",
          value: "track_code",
        },
        {
          text: "Код клиента",
          value: "user_code",
        },
        {
          text: "Статус",
          value: "status",
        },
      ],
      headerProps: {
        sortByText: "Сортировать",
      },
      isOpen: false,
    };
  },
  computed: { ...mapGetters(["isLoggedIn", "user", "roles"]) },
  mounted() {},
  methods: {
    ...mapActions(["searchUserGoodByTrack"]),
    async searchGood() {
      if (this.search) {
        const res = await this.searchUserGoodByTrack({ search: this.search });
        if (res && res?.length > 0) {
          this.searchItem = res;
        } else {
          this.$toast.warning("Товар с таким трек кодом не найден");
        }
        this.search = "";
      } else {
        this.$toast.warning("Введите трек код товара");
      }
    },
    showModal() {
      const userObj = JSON.parse(localStorage.getItem("user"));
      const refreshToken = localStorage.getItem("refreshToken");
      if (userObj && refreshToken) {
        const route = this.roles.find((el) => el.role === userObj.role);
        this.$router.push(route.url);
      } else {
        this.$router.push("login");
      }
    },
    findRegion(code) {
      const obj = this.regions?.find(
        (el) => el.code?.toLowerCase() === code?.toLowerCase(),
      );
      return obj?.name || code;
    },
    dateFormat(date) {
      return date ? moment(date).format("DD.MM.YYYY - HH:mm:ss") : ""; // .add(6, "hours")
    },
    datePickerFormat(date) {
      return moment(date, "DD.MM.YYYY - HH:mm").format();
    },
    datePickerFormat2(date) {
      return moment(date).toDate();
    },
    getCode() {
      const userObj = JSON.parse(localStorage.getItem("user"));
      const refreshToken = localStorage.getItem("refreshToken");
      if (userObj && refreshToken) {
        const route = this.roles.find((el) => el.role === userObj.role);
        this.$router.push(route.url);
      } else {
        this.isOpen = true;
      }
      const res = document.querySelector("body");
      if (res && res.classList.contains("mobile-nav-active")) {
        document.querySelector("body").classList.toggle("mobile-nav-active");
        const mobileNavShow = document.querySelector(".mobile-nav-show");
        const mobileNavHide = document.querySelector(".mobile-nav-hide");
        mobileNavShow.classList.toggle("d-none");
        mobileNavHide.classList.toggle("d-none");
      }
    },
    closeModal() {
      this.isOpen = false;
    },
  },
};
</script>
